import app from '../app.first';
import { drop, keys } from 'lodash';

app.MandatoryFiberQuestion = class extends app.Component {
    onReady () {
        this.dropdown     = this.$el.find('#pd_remote_work_capacity');
        this.mfqContainer = this.$el.find('.mfq-container');
        this.remoteCapacities = keys(this.$el.data('remote-capacities'));

        this.showContainer(this.dropdown.find(':selected')[0].value);

        this.dropdown.on('change', (evt) => {
            this.showContainer(evt.target.value);
        });
	}

    showContainer(dropdownValue) {
        let noInternet = ['unavailable', 'no_access', 'computer_access'];

        if (noInternet.indexOf(dropdownValue) >= 0) {
            this.$el.find('#has-fiber-access-0').prop('checked', true);
            this.mfqContainer.hide();
        } else {
            this.mfqContainer.show();
        }
    }
}
